module.exports = __webpack_public_path__ + "static/img/null.cdedfa8b.png";